<template>
  <div style="width: 100%; margin-left: 1rem; margin-right: 1rem" class="row">
    <div class="ant-modal-root order-detail_loader" v-if="loading">
      <div class="ant-modal-mask">
        <div
          class="ant-modal-wrap d-flex justify-content-center align-items-center"
        >
          <a-spin></a-spin>
        </div>
      </div>
    </div>
    <div class="col-sm-12 my-auto card" v-if="!loading">
      <a-form :form="form" @submit.prevent="submit">
        <div class="mt-3" v-if="!!profile">
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('account.firstName')"
            labelAlign="left"
          >
            <a-input
              v-decorator="[
                'firstname',
                {
                  rules: [{
                    required: true, message: $t('account.requiredFirstName')
                  }],
                  initialValue: profile ? profile.user_data.firstname : ''
                },
              ]"
              :placeholder="$t('account.requiredFirstName')"
              :disabled="isInitialValue"
              style="background-color: white; color: black;"
              v-if="!isInitialValue"
            />
            <div v-if="isInitialValue">
              {{ profile ? profile.user_data.firstname : '' }}
            </div>
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('account.lastName')"
            labelAlign="left"
          >
            <a-input
              v-decorator="[
                'lastname',
                {
                  rules: [{
                    required: true, message: $t('account.requiredLastName')
                  }],
                  initialValue: profile ? profile.user_data.name : ''
                },
              ]"
              :placeholder="$t('account.requiredLastName')"
              :disabled="isInitialValue"
              style="background-color: white; color: black;"
              v-if="!isInitialValue"
            />
            <div v-if="isInitialValue">
              {{ profile ? profile.user_data.name : '' }}
            </div>
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('account.phoneNumber')"
            labelAlign="left"
            :help="!isInitialValue && 'Hubungi customer service, jika ingin mengubah nomor telepon'"
          >
            <a-input
              v-decorator="[
                'phone',
                {
                  rules: [{
                    required: true,
                    message: $t('account.requiredPhoneNumber'),
                    pattern: new RegExp(/[0-9\+]+/g, '')
                  }],
                  initialValue: profile ? profile.user_data.phone : ''
                },
              ]"
              :placeholder="$t('account.requiredPhoneNumber')"
              :disabled="true"
              style="color: black;"
              v-if="!isInitialValue"
            />
            <div v-if="isInitialValue">
              {{ profile ? profile.user_data.phone : '' }}
            </div>
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('account.address')"
            labelAlign="left"
          >
            <a-input
              v-decorator="[
                'address',
                {
                  rules: [{
                    required: true,
                    message: $t('account.requiredAddress'),
                  }],
                  initialValue: profile ? profile.address_data.line1 : ''
                },
              ]"
              :placeholder="$t('account.requiredAddress')"
              :disabled="isInitialValue"
              style="background-color: white; color: black;"
              v-if="!isInitialValue"
            />
            <div v-if="isInitialValue">
              {{ profile ? profile.address_data.line1 : '' }}
            </div>
          </a-form-item>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="$t('account.address2')"
            labelAlign="left"
          >
            <a-input
              v-decorator="[
                'address_two',
                {
                  initialValue: profile ? profile.address_data.line2 : ''
                },
              ]"
              :placeholder="$t('account.requiredAddress2')"
              :disabled="isInitialValue"
              style="background-color: white; color: black;"
              v-if="!isInitialValue"
            />
            <div v-if="isInitialValue">
              {{ profile ? profile.address_data.line2 : '' }}
            </div>
          </a-form-item>
          <div v-if="isInitialValue">
            <a-form-item
              :label-col="{
                lg: { span: 3 }
              }"
              :wrapper-col="{
                lg: { span: 20 }
              }"
              :label="$t('account.city')"
              labelAlign="left"
            >
              <div v-if="isInitialValue">
                {{ initialValueCity }}
              </div>
            </a-form-item>
            <a-form-item
              :label-col="{
                lg: { span: 3 }
              }"
              :wrapper-col="{
                lg: { span: 20 }
              }"
              :label="$t('account.area')"
              labelAlign="left"
              v-if="isInitialValue"
            >
              <div v-if="isInitialValue">
                {{ initialValueArea }}
              </div>
            </a-form-item>
          </div>
          <div v-if="!isInitialValue">
            <a-form-item
              :label-col="{
                lg: { span: 3 }
              }"
              :wrapper-col="{
                lg: { span: 20 }
              }"
              :label="$t('account.city')"
              labelAlign="left"
            >
              <a-select
                show-search
                placeholder="Select a city"
                @change="handleChangeCity"
                v-decorator="[
                  'newcity',
                  {
                    rules: [
                      { required: true, message: 'Please select a city' },
                    ],
                    initialValue: initialValueCity ? initialValueCity : ''
                  },
                ]"
                style="background-color: white; color: black;"
              >
                <a-select-option
                  :value="city.label"
                  v-for="(city, index) in cityList"
                  :key="index"
                >
                  {{ city.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              :label-col="{
                lg: { span: 3 }
              }"
              :wrapper-col="{
                lg: { span: 20 }
              }"
              :label="$t('account.area')"
              labelAlign="left"
            >
              <a-select
                show-search
                placeholder="Select area"
                v-decorator="[
                  'newarea',
                  {
                    rules: [
                      { required: true, message: 'Please select area' },
                    ],
                    initialValue: initialValueArea ? initialValueArea : ''
                  },
                ]"
                style="background-color: white; color: black;"
              >
                <a-select-option
                  :value="area.label"
                  v-for="(area, index) in areaList"
                  :key="index"
                >
                  {{ area.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            :label="image.image_description"
            labelAlign="left"
            v-for="(image, index) in image"
            :key="index"
          >
            <div>
              <img :src="image.image_url" style="width: 150px; height: auto"/>
            </div>
            <div v-if="!isInitialValue">
              <a-upload
                :show-upload-list="false"
                name="image"
                :beforeUpload="() => false"
                @change="(file) => addImage(file, index)"
              >
                <div>
                  <a-button size="small" icon="plus">
                    Ganti Image
                  </a-button>
                </div>
              </a-upload>
            </div>
          </a-form-item>
          <!-- <a-form-item
            :label-col="{
              lg: { span: 3 }
            }"
            :wrapper-col="{
              lg: { span: 20 }
            }"
            label="NPWP"
            labelAlign="left"
          >
            <div v-if="image.length">
              <img :src="image[0].url" style="width: 150px; height: 150px"/>
            </div>
            <div v-else>
              <div v-if="profile && profile.npwp_url">
                <img :src="profile && `${profile.npwp_url}?tr=w-100,h-100,cm-pad_resize,bg-FFFFFF`" style="width: 150px; height: 150px" />
              </div>
            </div>
            <div>
              <a-upload
                :show-upload-list="false"
                name="image"
                :beforeUpload="() => false"
                @change="addImage"
                v-decorator="[
                  'image'
                ]"
              >
                <div>
                  <a-button size="small" icon="plus">
                    {{ !!image.length || (profile && profile.npwp_url) ? $t('account.changeImageNpwp') : $t('account.addImageNpwp') }}
                  </a-button>
                </div>
              </a-upload>
            </div>
          </a-form-item> -->
          <a-form-item v-if="!isInitialValue">
            <a-button
              type="primary"
              size="large"
              class="text-center mr-2"
              htmlType="submit"
            >
              <strong>Submit</strong>
            </a-button>
            <a-button
              size="large"
              class="text-center ml-2"
              @click.prevent="editProfile(true)"
            >
              <strong>Cancel</strong>
            </a-button>
          </a-form-item>
        </div>
      </a-form>
      <div class="mb-3" v-if="isInitialValue">
        <a-button type="primary" @click.prevent="editProfile(false)">Edit Profile</a-button>
      </div>
    </div>
    <div class="vld-parent">
      <loading-overlay
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
        :height="30"
        :width="30"
      ></loading-overlay>
    </div>
  </div>
</template>

<script>
import { getImagePreview } from '@/services/image/utils'
import { mapState } from 'vuex'
import LoadingOverlay from 'vue-loading-overlay'
export default {
  components: {
    LoadingOverlay,
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      image: [],
      isInitialValue: true,
      isNewValueCity: false,
    }
  },
  methods: {
    addImage ({ file }, index) {
      getImagePreview(file)
        .then(url => {
          const data = {
            file,
            url,
          }
          this.image = this.image.map((item, indexExisting) => {
            if (indexExisting === index) {
              return {
                image_url: data.url,
                image_description: item.image_description,
                file: data.file,
                content_id: item.content_id,
                is_edit: true,
              }
            } else {
              return { ...item }
            }
          })
        })
        .finally(() => {
          this.$nextTick()
        })
    },
    editProfile (param) {
      this.isInitialValue = param
      if (param) {
        this.form.resetFields()
        this.isNewValueCity = false
        this.image = this.profile.image_data.length ? this.profile.image_data.map(item => {
          return {
            is_edit: false,
            ...item,
          }
        }) : []
      }
    },
    handleChangeCity (e) {
      const findValueCity = this.cityList.find(item => item.label === e)
      this.$store.dispatch('data/GETCITYLIST', { value: findValueCity.value, type: 'area' })
      this.isNewValueCity = true
    },
    submit () {
      this.form.validateFieldsAndScroll((errors, values) => {
        if (errors) return
        this.$store.dispatch('account/EDITPROFILE', { image: this.image, ...values })
          .then(_ => {
            this.isInitialValue = true
            this.$notification.success({
              message: this.$t('account.successEditProfile'),
            })
          })
          .catch(err => {
            this.$notification.error({
              message: this.$t('account.failedEditProfile'),
              description: err.response?.data?.message || err.message,
            })
          })
      })
    },
  },
  computed: {
    ...mapState('account', {
      profile: state => state.profile,
      initialValueCity: state => state.initialValueCity,
      initialValueArea: state => state.initialValueArea,
      loading: state => state.loading,
    }),
    ...mapState('data', {
      cityList: state => state.cityList,
      areaList: state => state.areaList,
    }),
  },
  created () {
    this.$store.dispatch('account/GETUSERPROFILE')
  },
  watch: {
    profile (value) {
      if (!value) {
        return
      }
      const { image_data } = value
      const arrImage = []
      image_data.map(item => {
        this.$store.dispatch('account/AWSGETIMAGE', item.ref_id)
          .then(data => {
            var urlCreator = window.URL || window.webkitURL
            var imageUrl = urlCreator.createObjectURL(data)
            arrImage.push({
              ...item,
              is_edit: false,
              image_url: imageUrl,
            })
          })
      })
      console.log(arrImage)
      this.image = arrImage
    },
  },
}
</script>

<style lang="scss">
.image-uploader {
  .ant-upload-select-picture-card {
    margin: 0 !important;
    width: 140px !important;
    height: 140px !important;

    img {
      max-width: 100%
    }

    i {
      font-size: 32px;
      color: #999;
    }

    .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }
  }
}
</style>
